// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3XNLK","title":"ClientReferral_title__3DqWj","itemText":"ClientReferral_itemText__3rw7Q"};